import createSlice from "admin/store/create-slice";
import initialState from "admin/store/initial-state-schema";
import { baseReducers, getBaseActions } from "./base";

const name = 'brand';

const slice = createSlice({
    name,
    initialState,
    reducers: baseReducers
});

const { _set, requested, failed, itemReceived, itemsReceived, deleteReceived, submitReceived } = slice.actions;

export default slice.reducer;

const { baseSet, baseGet, baseGetAll, baseSubmit, baseDelete } = getBaseActions(requested.type, failed.type);

export const set = payload => baseSet(_set.type, payload);

export const get = id => baseGet(name, itemReceived.type, { id });

export const getAll = data => baseGetAll(name, itemsReceived.type, data);

export const submit = data => baseSubmit(name, submitReceived.type, data);

export const remove = ids => baseDelete(name, deleteReceived.type, ids);